<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>审单管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form
        :model="search"
        :rules="searchRules"
        ref="searchForm"
        label-width="96px"
        label-position="right"
        size="medium"
        @submit.native.prevent="onSearch()"
      >
        <div class="re-el-form__flex">
          <el-form-item label="复核人" prop="admin_id">
            <remote-select
              placeholder="请输入用户名称搜索"
              v-model="search.admin_id"
              id-key="id"
              label-key="name"
              value-key="id"
              keyword-key="name"
              :query-request="queryPlatformUsers"
              :find-request="findPlatformUser"
              clearable
            />
          </el-form-item>

          <el-form-item label="日期" prop="plan_date">
            <el-date-picker
              v-model="search.plan_date"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择"
              clearable
              class="width-max"
              align="right"
            />
          </el-form-item>
        </div>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" native-type="submit">搜索</el-button>
          <el-button icon="el-icon-download" type="warning" @click="onExportSearch()">按搜索结果导出</el-button>
          <el-button @click="onResetSearch()" icon="el-icon-refresh-left">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary" size="small" icon="el-icon-refresh" @click="onRefresh()" />
      </template>

      <div class="margin b15">
        <el-button type="primary" icon="sj-icon-add" size="small" @click="$router.push({ path: '/task/review-plan/form' })">
          添加复核目标
        </el-button>
      </div>

      <el-table :data="table" stripe highlight-current-row border style="width: 100%" v-loading="loading">
        <template v-for="attr of fields">
          <el-table-column v-bind="attr" :key="attr.prop" />
        </template>

        <el-table-column fixed="right" label="操作" width="120px">
          <template slot-scope="scope">
            <div class="button-gutter">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="$router.push({ path: `/task/review-plan/form/${scope.row.id}` })"
              >
                编辑
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          background
          @size-change="handleSizePageChange"
          @current-change="handleCurrentPageChange"
          :current-page="pagination.current_page"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pagination.per_page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        />
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table, { removeEmptyParams } from '@core/mixins/table-v3'
import { getPlatformUsersIndex, getPlatformUsersDetail } from '@/views/platform-user/platform-user.api'

export default {
  name: 'ReviewPlanTable',
  mixins: [table],
  data () {
    return {
      loading: false,
      searchRules: {},
      search: {
        admin_id: null,
        plan_date: null,
      },
      // 用于 fields 配置列渲染（ElementUI 的 prop/label 等字段名与该对象一一对应）
      fields: [
        { prop: 'id', label: 'ID', minWidth: 60 },
        { prop: 'admin_cn', label: '复核人', minWidth: 120 },
        { prop: 'review_target', label: '复核目标单量', minWidth: 140 },
        { prop: 'plan_date', label: '日期', minWidth: 120 },
        { prop: 'is_reached_cn', label: '是否达标', minWidth: 100 },
        { prop: 'reviewed_count', label: '实际单量', minWidth: 120 },
        { prop: 'updated_at', label: '更新时间', minWidth: 160 },
      ],
      searchFieldType: {
        current_page: Number,
        per_page: Number,
      },
    }
  },
  computed: {
    exportHeader () {
      return [
        { key: 'id', text: 'ID' },
        { key: 'admin_cn', text: '复核人' },
        { key: 'review_target', text: '复核目标单量' },
        { key: 'plan_date', text: '日期' },
        { key: 'is_reached_cn', text: '是否达标' },
        { key: 'reviewed_count', text: '实际单量' },
        { key: 'updated_at', text: '更新时间' },
      ]
    },
  },
  methods: {
    queryPlatformUsers (params) {
      return getPlatformUsersIndex(params || {}).then((res) => {
        const body = res && res.data
        let list = []
        if (body && body.detail && Array.isArray(body.detail.data)) {
          list = body.detail.data
        } else if (body && Array.isArray(body.data)) {
          list = body.data
        }
        return { data: { data: list } }
      })
    },
    findPlatformUser (params) {
      return getPlatformUsersDetail(params || {}).then((res) => {
        const body = res && res.data
        let item = body
        if (body && body.detail) {
          const candidate = body.detail
          // 有的接口 detail 在内，有的接口可能直接在根层携带字段
          item = (candidate && (candidate.id != null || candidate.name != null)) ? candidate : body
        }
        return { data: item }
      })
    },
    getTableData (params) {
      this.loading = true
      return request.page('queryReviewPlanTable', params).then(({ data }) => {
        const rawList = Array.isArray(data && data.data) ? data.data : []
        const list = rawList.map((row) => {
          const targetKnown = row.review_target !== null && row.review_target !== undefined && row.review_target !== ''
          const actualKnown = row.reviewed_count !== null && row.reviewed_count !== undefined && row.reviewed_count !== ''

          const target = targetKnown ? Number(row.review_target) : null
          const actual = actualKnown ? Number(row.reviewed_count) : null

          const isReachedCn = (target === null || actual === null)
            ? ''
            : (actual >= target ? '是' : '否')

          const adminCn = row.adminname || row.admin_name || row.admin_id || '-'

          return Object.assign({}, row, {
            admin_cn: adminCn === '' ? '-' : adminCn,
            is_reached_cn: isReachedCn,
          })
        })

        return { data: Object.assign({}, data, { data: list }) }
      }).finally(() => {
        this.loading = false
      })
    },
    onResetSearch () {
      this.resetSearch()
      this.onSearch({})
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: removeEmptyParams(_.cloneDeep(this.search)),
      })
    },
  },
}
</script>

<style scoped>
.pagination {
  margin-top: 20px;
  text-align: center;
}

.button-gutter {
  display: flex;
  gap: 5px;
}
</style>




// WEBPACK FOOTER //
// src/views/task/pages/ReviewPlanTable.vue